export default "__VITE_ASSET__BBMSs57y__"